"use client";
import Lottie from "lottie-react";
import CommonSubtitle from "../common/CommonSubtitle";
import adBgImage from "@/assets/images/advertisement/bg-ad-banner.svg";
// import robotImage from "@/assets/images/advertisement/robot.svg";
import robotAnimation from "@/assets/images/robot-animate.json";
import {
  BookDemoHubspotButtonUrl,
  SignUpHubspotButtonUrl,
} from "@/utils/hubspot-contants";
import CommonTitle from "../common/CommonTitle";
import CustomButton from "../common/CustomButton";
import appleLogo from "@/assets/images/footer/apple-store2.svg";
import playStoreLogo from "@/assets/images/footer/play-store2.svg";
import Image from "next/image";
import Link from "next/link";

const AdBanner = ({
  title,
  subtitle,
  btnText,
  url,
  twoButtons,
  appDownloadBtn,
}: {
  title?: React.ReactNode;
  subtitle?: string;
  btnText?: string;
  url?: string;
  twoButtons?: boolean;
  appDownloadBtn?: boolean;
}) => {
  return (
    <div className="relative z-10 overflow-hidden">
      <div
        className="absolute left-0 top-0 -z-10 h-full w-full"
        style={{
          backgroundImage: `url(${adBgImage.src})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <section className="py-6 xlg:py-12">
        <div className="container">
          <div className="flex flex-col items-center justify-center gap-[20px]">
            <div className="flex h-[200px] w-[200px] items-center justify-center" aria-hidden="true">
              <Lottie
                animationData={robotAnimation}
                alt="Kroolo AI - Try free CTA banner"
                className="h-full w-full object-contain"
                loop
                autoplay
              />
            </div>
            <div className="flex flex-col items-center space-y-2.5 text-center xl:space-y-8">
              <div className="flex flex-col items-center gap-4">
                <CommonTitle
                  color="#FFFFFF"
                  fontSizeClass="text-[26px] xl:text-[48px] text-center"
                  fontWeightClass="font-semibold"
                  as="h2"
                >
                  {title || (
                    <>
                      Get Kroolo, The best of <br />
                      <span className="bg-gradient-to-r from-[#BB34FF] to-[#FF3465] bg-clip-text text-transparent">
                        AI and Work Management
                      </span>
                    </>
                  )}
                </CommonTitle>
                <div className="flex gap-2">
                  <CommonSubtitle
                    color="#fff"
                    fontSizeWeight="text-[14px] font-normal xl:text-[16px] max-w-[600px]"
                  >
                    {subtitle || "Start for Free. Upgrade anytime!"}
                  </CommonSubtitle>
                </div>
              </div>
              {appDownloadBtn && (
                <div className="flex items-center gap-2">
                  <Link
                    href={"https://apps.apple.com/in/app/kroolo/id6740263578"}
                    target="_blank"
                  >
                    <Image src={appleLogo} alt="Download Kroolo on App Store" width={120} height={24} />
                  </Link>
                  <Link
                    href={"https://play.google.com/store/apps/details?id=com.kroolo.app"}
                    target="_blank"
                  >
                    <Image
                      src={playStoreLogo}
                      alt="Get Kroolo on Google Play Store"
                      width={120}
                      height={24}
                    />
                  </Link>
                </div>
              )}
              {(twoButtons && !appDownloadBtn && (
                <div className="flex items-center gap-2">
                  <CustomButton
                    text="Get Started Free"
                    url={SignUpHubspotButtonUrl}
                    target="_blank"
                    version="white"
                    variant="primary"
                  />
                  <CustomButton
                    text="Talk to Sales"
                    url={BookDemoHubspotButtonUrl}
                    version="white"
                    variant="secondary"
                  />
                </div>
              )) || (!appDownloadBtn && (
                <CustomButton
                  text={btnText || "Try it free"}
                  url={url || SignUpHubspotButtonUrl}
                  version="white"
                  variant="primary"
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdBanner;
